import {
  Component, 
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  TemplateRef,
  HostListener,
  ElementRef,
} from '@angular/core';
import {SelectionModel} from '@angular/cdk/collections';
// import { BulkUploadOrdersComponent } from '../bulk-upload-orders/bulk-upload-orders.component';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { ValidationService } from '../validation.service';
import {MatDialog,MatDialogRef,MAT_DIALOG_DATA,} from "@angular/material/dialog";
import {MatPaginator,PageEvent, MatTableDataSource, MatSort, Sort, MatAutocompleteTrigger } from '@angular/material';
import { TimeService } from '../time.service';
import { DateTime } from "luxon";
import { Subscription } from 'rxjs';
import { EventService } from '../event.service';
@Component({
  selector: 'app-free-load',
  templateUrl: './free-load.component.html',
  styleUrls: ['./free-load.component.scss']
})
export class FreeLoadComponent implements OnInit {

  files: any[] = [];
  editDialogRef: MatDialogRef<any, any>;
  selectedData: any;
  reason: any = '';
  sample: any = 'https://docs.google.com/spreadsheets/d/116nGRFaoSpsnCZY1vfjE2uuvfbuZ73BcGC18pv1BYGo/edit#gid=2011295651';
  shipper_type: any;
  fileChoosen: any;
  validTotal = false;
  

  @ViewChild('reportDialog', { static: true }) reportDialog: TemplateRef<any>;
  @ViewChild('editCarrierLoad', { static: true }) editCarrierLoad: TemplateRef<any>;

  @ViewChild('loadBulkUploadDialog', { static: true }) loadBulkUploadDialog: TemplateRef<any>;
  @ViewChild('fileUploader', { static: true }) fileUploader: ElementRef;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  // @ViewChild(MatPaginator) paginator: MatPaginator;
  // displayedColumns: string[] = ['select','Sno', 'lin','uploadedDate', 'material', 'state', 'customer', 'carriers', 'load', 'actions']
  displayedColumns: string[] = ['select', 'customerDetails', 'material', 'availableLoad', 'actions'];

  dataSource: any = new MatTableDataSource();
  showLoader = false;
  ordersArray: any = [];
  orders: any = [];
  Organisations: any[];
  selectedOrderData: any;
  allocationArray = [];
  created_date = "";
  acceptanceDeadlineDateOnly = "";
  acceptanceDeadlineTimeOnly = "";
  assignmentDeadlineDateOnly = "";
  assignmentDeadlineTimeOnly = "";
  showStatusTab = 0;
  showOrderDetailsView = 0;
  allocationStatus: any = {
    versions: [],
    totalWeight: 0,
    totalAccepted: 0,
  };
  reportDialogRef: any = '';
  reportFromDate: any = '';
  reportToDate: any = '';
  filtersDialogRef: any;
  tabIndex = 0;
  loadUploadDialogRef: MatDialogRef<any, any>;
  fileover: boolean;
  before_allocation = true;
  selectedIds = [];
  selectedOrganization: any = {};
  organizationsArray: any = [];
  formData: FormData;
  carrierId: Subscription;
  carriers: any;
  totalOrders=0;
  loadsFilter: any = {
    limit: 0,
    skip: 0,
  };

  constructor(
    private http: HttpService,
    private snackBar: SnackbarService,
    public timeService: TimeService,
    private time: TimeService,
    private valid: ValidationService,
    private dialog: MatDialog,
    private events: EventService
  ) {}

  ngOnInit() {
    // const typeData = JSON.parse(localStorage.getItem('shippers'));
    // this.shipper_type = (typeData[0].type) ? (typeData[0].type) : 'normal';
    this.carrierId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        // this.getOrganisations();
        this.getOrders();
        // this.getCarriers();
      }
    );
    // this.getOrganisations();
    this.getOrders();
    // this.getCarriers();

    // this.dataSource.paginator = this.paginator;
  }
  onFileDropped($event) {
    this.prepareFilesList($event);
  }
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }
   prepareFilesList(files: Array<any>) {
    
    if (files[0].type === 'text/csv' && files.length === 1) {
      for (const item of files) {
        item.progress = 0;
        this.files.push(item);
      }
      // this.uploadFilesSimulator(0);
    } else this.snackBar.openSnackBar('Please upload only CSV file', '', 'err');
    
  }

  deleteFile(index: number) {
    this.files = [];
  }
  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  // getOrganisations() {
  //   this.showLoader = true;
  //   this.http.get('shipper_pref').subscribe(
  //     (data: any) => {
  //       this.showLoader = false;
  //       if (data.statusCode == 200) {
  //         if (data.data.organizations.length) {
  //           this.organizationsArray = data.data.organizations;
  //           if (this.shipper_type != '4pl') {
  //             this.selectedOrganization = this.organizationsArray[0];
  //           }
  //         }
  //       }
  //     }
  //   );
  // }
  // openBulkUpload() {
  //   const dialogRef = this.dialog.open(BulkUploadOrdersComponent, {
  //     data: {
  //       organizations: this.Organisations,
  //       type: "Load",
  //     },
  //   });
  //   dialogRef.afterClosed().subscribe(
  //     (data: any) => {
  //       if (data && data.statusCode === 200) {
  //         this.getOrders();
  //       }
  //     },
  //     (err: any) => {
  //       this.snackBar.openSnackBar(err.error.message, "", "err");
  //       if (err.error.statusCode == 401) {
  //         this.valid.logout();
  //       }
  //     }
  //   );
  // }
  getOrders(filters: any = {}) {
    filters.limit = this.paginator.pageSize || 25;
    filters.skip = this.paginator.pageIndex * (this.paginator.pageSize || filters.limit);
    this.http.get("free_loads").subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.ordersArray = data.data;
          
          this.ordersArray.forEach(order => {
            const temp:any = {};
            temp.allocatedDateTime = this.timeService.toShortDateTime24(order.created_at);
            temp.availableLoad = order.available_load && order.available_load.map(load => `${this.timeService.toShortDate(load.date)} - ${load.weight} MT`);
            temp.availableLoad.push(`Total - ${order.total_weight}`);
            temp._id = order._id;
            temp.customerDetails = order.customer && `${order.customer.reference} - ${order.customer.name}`;
            temp.state = order.state && order.state.name;
            temp.city = order.city;
            temp.allocated = order.total_weight;
            temp.material = order.material ? order.material.name : 'N/A';
            temp.preSelectedCarriers = order.carriers && order.carriers.map((carrier) => { return {
              _id: carrier._id,
              name: carrier.parent_name
            }});
            this.orders.push(temp);
          })
          if (!this.dataSource) {
            this.dataSource = new MatTableDataSource(this.orders);            
          } else {
            this.dataSource = new MatTableDataSource(this.orders);            
          }

        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, "", "err");
        // this.paginator._intl.itemsPerPageLabel = this.translation.instant(
        //   "DASHBOARD.pagination_label"
        // );
        if (err.error.statusCode == 401) {
          // this.valid.logout();
        }
      }
    );
  }
  formatTime(time) {
    return this.time.toShortDateTime(time, "dd-MMM-yyyy");
  }
  openAssignSideModal(element1) {
    this.allocationStatus = {
      versions: [],
      totalWeight: 0,
      totalAccepted: 0,
    };
    this.allocationStatus.totalWeight = element1.total_weight;
    this.allocationStatus.totalAccepted = element1.accepted || 'N/A';
    this.showLoader = false;
    this.showStatusTab = 1;
    const allocationData = [element1];

    this.allocationStatus.versions = [];
    allocationData.forEach((element) => {
      const temp: any = {
        allocationArray: [],
      };
      temp.version = element1.created;
      temp.totalRejected = 0;
      element.allocations.forEach((item) => {
        const arr: any = {};
        arr.carrierName = item.carrier.parent_name;
        arr.allocated = item.allocated;
        arr.accepted = item.accepted;
        arr.acceptance_deadline = item.acceptance_deadline;
        arr.assignment_deadline = item.assignment_deadline;
        arr.carrier_id = item.carrier._id;
        temp.totalRejected += item.rejected;
        temp.acceptance_deadline_dateOnly = item.acceptance_deadline
          ? this.timeService.toShortDate(item.acceptance_deadline)
          : "N/A";
        temp.acceptance_deadline_timeOnly = item.acceptance_deadline
          ? this.timeService.toShortDate(item.acceptance_deadline, "hh:mm a")
          : "N/A";
        temp.assignment_deadline_dateOnly =
          this.timeService.toShortDate(item.assignment_deadline) || "N/A";
        temp.assignment_deadline_timeOnly =
          this.timeService.toShortDate(item.assignment_deadline, "hh:mm a") ||
          "N/A";
        temp.allocationArray.push(arr);
      });
      this.allocationStatus.versions.push(temp);
    });

    this.allocationStatus.versions.sort((a, b) => {
      return this.timeService.compareDate(a.version, b.version, false);
    });
  }
  openReportDialog() {
    this.clearReportDialog();
    this.reportDialogRef = this.dialog.open(this.reportDialog);
  }
  openEditDialog(element) {
    this.reason = '';
    this.selectedData = element;
    this.selectedData.allocations = this.selectedData.allocations.map(e => {
      return {
        ...e,
        editAllocated: 0,
        invalid: false,
      }
    });
    this.editDialogRef = this.dialog.open(this.editCarrierLoad);
  }
  generateReport() {
    let url = "loadAllocation";
    let request: any = {};
    if (this.reportFromDate && this.reportToDate) {
      let from: any = DateTime.fromJSDate(this.reportFromDate).startOf("day").toUTC();
      let to: any = DateTime.fromJSDate(this.reportToDate).endOf("day").toUTC();
      request.from = from.ts;
      request.to = to.ts;
      
      this.http.post("v1/reports/" + url, request, 2).subscribe(
        (response: any) => {
          window.open(response.data.link, "_blank");
          if (this.filtersDialogRef) this.filtersDialogRef.close();
        },
        (err: any) => {          
          this.snackBar.openSnackBar(err.error.message, "", "err");
        }
      );
    } else {
      this.snackBar.openSnackBar('from and to date mandatory', "", "err");
    }

  }

  clearReportDialog() {
    this.reportFromDate = '';
    this.reportToDate = '';
  }
 
  selection = new SelectionModel(true, []);

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.data);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?): string {
    if (this.selection.isSelected(row)) {
      this.selectedIds.push(row._id);
    } else if(row && row._id && this.selectedIds.indexOf(row._id) > -1) {
      this.selectedIds.splice(this.selectedIds.indexOf(row._id), 1);
    } 
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }
  switchTab(tab: number) {
    this.tabIndex = tab;
    // this.loadTabWiseData();
    if (tab == 0) {
      this.displayedColumns = ['select','Sno', 'lin','uploadedDate', 'material', 'state', 'customer', 'carriers', 'load', 'actions'];
      this.before_allocation = true;
      this.getOrders();
    }
    if (tab == 1) {
      this.before_allocation = false;

      this.displayedColumns = ['select','Sno', 'lin','uploadedDate', 'material', 'state', 'customer', 'deadline', 'carriers', 'load', 'actions'];
      this.getOrders();
    }
    
  }

  openLoadBulkUpload() {
    this.loadUploadDialogRef = this.dialog.open(this.loadBulkUploadDialog);
  }
  allocate() {
    // this.selectedIds = this.selection.selected.map(m => m.id);
    this.selectedIds = this.selection.selected;

    console.log("🚀 ~ file: free-load.component.ts:451 ~ FreeLoadComponent ~ approve ~  this.selectedIds:",  this.selectedIds);
    // this.http.post('loads/approve', { approved_loads: this.selectedIds }).subscribe(
    //   (data: any) => {
    //     if (data.statusCode === 200) {
    //       this.snackBar.openSnackBar('Approved Successfully', '');
    //       this.getOrders();
    //     }
    //   },
    //   (err: any) => {
    //     this.snackBar.openSnackBar(err.error.message, '', 'err');
    //   }
    // )
  }
  downloadSample() {
    window.open(this.sample, '_blank');
  }
  upload() {
    if (this.files.length) {
    this.formData = new FormData();
        this.formData.append('weight_orders', this.files[0], this.files[0].name);
        this.http.upload('v1/loads/bulk_weight_allocation/' + this.selectedOrganization._id, this.formData).subscribe(
          (data: any) => {
            this.showLoader = false;
            if (data.statusCode == 200) {
              this.snackBar.openSnackBar('Uploaded Successfully', '');
              this.getOrders();
              this.loadUploadDialogRef.close();
            }
          },
          (err: any) => {
            this.showLoader = false;
            this.formData = new FormData();
            this.fileUploader.nativeElement.value = null;
            this.fileChoosen = null;
            this.snackBar.openSnackBar(err.error.message, '', 'err');
            if (err.error.statusCode == 401) {
              this.valid.logout();
            }
          }
        );
    } else this.snackBar.openSnackBar('Please Upload a File', '', 'err');
  }
  checkTotal(index) {
    const sum = this.selectedData.allocations.reduce((acc, curr) => acc + curr.editAllocated, 0);
    if (sum > this.selectedData.totalWeight) {
      this.selectedData.allocations[index].invalid = true;
      this.snackBar.openSnackBar(`Total Load Cannot be greater than ${this.selectedData.totalWeight}`, '', 'err');
      this.validTotal = false;
    } else {
      this.selectedData.allocations[index].invalid = false;
      this.validTotal = true;
    }
  }
  editLoad() {
    if (this.validTotal) {
      const payload = {
        _id: this.selectedData._id,
        reason: this.reason,
        allocations: this.selectedData.allocations.map((allocation) => {
          return {
            _id: allocation._id,
            allocated: allocation.editAllocated
          }
        })
      };
      this.http.post('/load/edit', payload).subscribe(
        (data: any) => {
          if (data.statusCode === 200) {
            this.snackBar.openSnackBar('Update Successful', '');
            this.getOrders();
            this.editDialogRef.close();
          }
        },
        (err: any) => {
          this.snackBar.openSnackBar(err.error.message, '', 'err');
        } 
        )
      
    } else this.snackBar.openSnackBar(`Total Load Cannot be greater than ${this.selectedData.totalWeight}`, '', 'err');
    
  }
  closeUploadDialog() {
    this.selectedOrganization = {};
    this.files = [];
    this.loadUploadDialogRef.close();
  }
  onSelectedCarriersChange(row: any, selectedCarriers: any[]): void {
    row.selectedCarriers = selectedCarriers;
    console.log('Selected carriers for row with ID', row.id, ':', selectedCarriers);
  }

  getCarriers() {
    this.http.get("carriers").subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.carriers = data.data.map(carrier => {
            return {
              _id: carrier._id,
              name: carrier.parent_name,
            }
          });
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, "", "err");

      }
    );
  }
  acceptLoad (element){
    
    let data = {
      load_allocation_id: element._id,
      accepted_load: element.allocated
    }

    this.http.post('loads/accept', data).subscribe(
      (data: any) => {

        if (data.statusCode === 200) {
          this.snackBar.openSnackBar('Load Accepted Successfully', '');
          this.showStatusTab=0;
          this.getOrders();
        }

      },
      (err: any) => {

        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  pageNavigate(event: PageEvent) {
    this.loadsFilter.limit = event.pageSize;
    this.loadsFilter.skip = event.pageIndex * event.pageSize;
    this.getOrders();
  }

  ngOnDestroy() {
    this.carrierId.unsubscribe();
  }


}
